export default "__VITE_ASSET__DXiu7q2m__"